// The lobby name step the server puts in the HTML for first-time guests (lib/lobby-fast-join.js,
// TEAMBRIDGE_LOBBY_FAST_JOIN). The app's own step takes over what was typed (and a Continue already pressed),
// or the page drops it when that visitor gets another step.
const OVERLAY_ID = 'tb-fast-join';
const overlay = (doc = typeof document === 'undefined' ? null : document) => doc?.getElementById(OVERLAY_ID) || null;

// What the visitor did so far, while the HTML step is still on screen; null otherwise.
export function peekFastJoin(win = typeof window === 'undefined' ? null : window) {
  if (!win || !overlay(win.document)) return null;
  const state = win.__tbFastJoin || {};
  return {
    name: String(state.name || '').slice(0, 32),
    submitted: Boolean(state.submitted),
    focused: Boolean(state.focused)
  };
}

// Removes the HTML step; returns what peekFastJoin returned.
export function takeFastJoin(win = typeof window === 'undefined' ? null : window) {
  const state = peekFastJoin(win);
  overlay(win?.document)?.remove();
  return state;
}
export const dropFastJoin = takeFastJoin;